let current = new AbortController();

export function pageSignal() {
  return current.signal;
}

export function rotatePageAbort() {
  current.abort();
  current = new AbortController();
}

export function combineSignals(...signals) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  for (const signal of signals) {
    if (!signal) continue;
    if (signal.aborted) {
      abort();
      return controller.signal;
    }
    signal.addEventListener("abort", abort, { once: true });
  }
  return controller.signal;
}
